import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const GRID_BG = {
  backgroundImage: 'linear-gradient(rgba(0,0,0,0.022) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.022) 1px, transparent 1px)',
  backgroundSize: '44px 44px',
};

const PRODUCTS = [
  {
    to: '/tradiepro',
    icon: '⚡',
    tint: '#F6E7E1',
    accent: '#C0492A',
    name: 'TradiePro',
    tag: 'TRADES & HOME SERVICES',
    desc: 'A Kanban work-order dashboard for tradies. Client emails become jobs automatically — track, manage, and close them without lifting a finger.',
    bullets: [
      'Email-to-dashboard, zero manual entry',
      'Visual board: Open → In Progress → Closed',
      'Auto-confirmation sent when a job is done',
    ],
  },
  {
    to: '/rostering',
    icon: '🏥',
    tint: '#EAEDE2',
    accent: '#5E6B39',
    name: 'Rostering Automation',
    tag: 'HEALTHCARE & AGED CARE',
    desc: 'AI-powered shift replacement for care facilities. When staff call in sick, Custodian AI finds, notifies, and confirms a replacement automatically.',
    bullets: [
      'Fills open shifts in ~4 minutes',
      'SMS, Email & Teams notifications',
      'Every action logged for compliance',
    ],
  },
];

const Products = () => (
  <div style={{ background: '#ECEAE3', minHeight: '100vh', ...GRID_BG }}>
    <Header />

    <section style={{ maxWidth: 1100, margin: '0 auto', padding: '72px 40px 0', textAlign: 'center' }}>
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 9, background: '#fff', borderRadius: 999, padding: '9px 18px', fontSize: 12, fontWeight: 700, letterSpacing: '0.08em', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', marginBottom: 24 }}>
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#5E6B39', display: 'inline-block' }} />
        LIVE AUTOMATION PRODUCTS
      </div>
      <h1 style={{ fontSize: 'clamp(2.2rem, 4.5vw, 3.5rem)', fontWeight: 800, letterSpacing: '-0.03em', margin: 0, lineHeight: 1.05, color: '#1A1A18' }}>
        Real tools. Real businesses.<br />Built for the way Kiwis work.
      </h1>
      <p style={{ fontSize: 20, lineHeight: 1.55, color: '#5A564D', maxWidth: 620, margin: '22px auto 0' }}>
        Two production-ready automation products you can put to work today — purpose-built for the industries that keep business running.
      </p>
    </section>

    <section style={{ maxWidth: 1100, margin: '0 auto', padding: '56px 40px 0' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 26 }}>
        {PRODUCTS.map(p => (
          <Link key={p.name} to={p.to} style={{ display: 'block', textDecoration: 'none', color: 'inherit', background: '#fff', borderRadius: 24, padding: 40, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'transform .2s, box-shadow .2s' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
              <div style={{ width: 58, height: 58, borderRadius: 16, background: p.tint, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 30, flexShrink: 0 }}>{p.icon}</div>
              <div>
                <div style={{ fontSize: 24, fontWeight: 800, letterSpacing: '-0.02em', color: '#1A1A18' }}>{p.name}</div>
                <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.04em', color: p.accent }}>{p.tag}</div>
              </div>
            </div>
            <p style={{ fontSize: 16, lineHeight: 1.6, color: '#5A564D', margin: '0 0 24px' }}>{p.desc}</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 26 }}>
              {p.bullets.map(b => (
                <div key={b} style={{ display: 'flex', gap: 10, fontSize: 15, color: '#3A3730' }}>
                  <span style={{ color: '#5E6B39', fontWeight: 800, flexShrink: 0 }}>✓</span>
                  <span>{b}</span>
                </div>
              ))}
            </div>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 15, fontWeight: 700, color: p.accent }}>View product →</span>
          </Link>
        ))}
      </div>
    </section>

    <section style={{ maxWidth: 1100, margin: '72px auto 0', padding: '0 40px 80px' }}>
      <div style={{ background: '#1A1A18', color: '#fff', borderRadius: 28, padding: 56, textAlign: 'center' }}>
        <h2 style={{ fontSize: 'clamp(1.6rem, 2.5vw, 2.1rem)', fontWeight: 800, letterSpacing: '-0.02em', margin: 0 }}>
          Need something built for your business?
        </h2>
        <p style={{ fontSize: 18, color: '#B5B0A5', margin: '14px 0 30px' }}>
          If TradiePro or Rostering isn't quite your fit, we'll build automation that is.
        </p>
        <Link to="/#booking" style={{ display: 'inline-block', background: '#C0492A', color: '#fff', fontSize: 17, fontWeight: 700, padding: '16px 32px', borderRadius: 13, textDecoration: 'none' }}>
          Book a free automation audit →
        </Link>
      </div>
    </section>
    <Footer />
  </div>
);

export default Products;
